<template>
    <div v-if="ready">
        <form
            class="form-horizontal fr-absolute"
            enctype="multipart/form-data"
            @submit.prevent="store"
            @keydown="form.errors.clear($event.target.name)"
            novalidate
            autocomplete="off"
        >
            <backend-select
                :error="form.errors.get('type_id')"
                :value="field('type_id')"
                v-model="selected_relation_type"
                name="type_id"
                label="type"
                :route="route('types.index')"
                v-if="!organisationId"
                @optionsRetrieved="onTypesRetrieved"
                :hidden="!$can('update-relations')"
            />

            <backend-select
                :error="form.errors.get('organisation_id')"
                return="id"
                :value="field('organisation_id')"
                v-model="form.organisation_id"
                name="organisation"
                label="organisation"
                :route="route('organisations.index')"
                v-if="$can('update-relations')
                    && showOrganisation
                    && (weAreCreatingA('coach')
                    || weAreCreatingA('id_employee')
                    || weAreCreatingA('client')
                    || weAreCreatingA('supplier'))"
                :disabled="organisationId !== undefined && organisationId !== null"
            />

            <form-input
                :form="form"
                name="job_title"
                :hidden="!$can('update-relations')"
                v-if="$can('update-relations')
                    && (weAreCreatingA('id_employee')
                    || weAreCreatingA('client')
                    || weAreCreatingA('supplier'))"
            />

            <salutation-select
                :error="form.errors.get('title')"
                :value="form.title"
                v-model="form.title"
                :hidden="!$can('update-relations')"
                required
                @keydown="form.errors.clear('title')"
                v-if="weAreCreatingA('coach')
                    || weAreCreatingA('candidate')
                    || weAreCreatingA('id_employee')
                    || weAreCreatingA('client')
                    || weAreCreatingA('supplier')"
            />

            <form-input
                :hidden="!$can('update-relations')"
                :form="form"
                name="first_letters"
                v-if="weAreCreatingA('coach')
                    || weAreCreatingA('candidate')
                    || weAreCreatingA('id_employee')
                    || weAreCreatingA('client')
                    || weAreCreatingA('supplier')"
            />

            <form-input
                :form="form"
                :hidden="!$can('update-relations')"
                name="first_name"
                v-if="weAreCreatingA('coach')
                    || weAreCreatingA('candidate')
                    || weAreCreatingA('id_employee')
                    || weAreCreatingA('client')
                    || weAreCreatingA('supplier')"
            />

            <form-input
                :form="form"
                :hidden="!$can('update-relations')"
                name="prefix"
                v-if="weAreCreatingA('coach')
                    || weAreCreatingA('candidate')
                    || weAreCreatingA('id_employee')
                    || weAreCreatingA('client')
                    || weAreCreatingA('supplier')"
            />

            <form-input
                :form="form"
                :hidden="!$can('update-relations')"
                required
                name="last_name"
                v-if="weAreCreatingA('coach')
                    || weAreCreatingA('candidate')
                    || weAreCreatingA('id_employee')
                    || weAreCreatingA('client')
                    || weAreCreatingA('supplier')"
            />

            <form-date-picker
                :hidden="!$can('update-relations')"
                :form="form"
                name="sickness_started_at"
                initial-view="day"
                v-if="weAreCreatingA('candidate')"
            />

            <form-date-picker
                :form="form"
                name="birth_date"
                :hidden="!$can('update-relations')"
                initial-view="year"
                :open-date="new Date(1960,1,1)"
                v-if="weAreCreatingA('coach')
                    || weAreCreatingA('candidate')"
            />

            <phone-number
                :error="form.errors.get(['phone_number_call_code', 'phone_number'])"
                :phone-number="{ call_code: form.phone_number_call_code, phone_number: form.phone_number }"
                v-model="phone_number"
                name="phone_number"
                v-if="weAreCreatingA('coach')
                    || weAreCreatingA('candidate')
                    || weAreCreatingA('id_employee')
                    || weAreCreatingA('client')
                    || weAreCreatingA('supplier')"
            />

            <phone-number
                :error="form.errors.get(['mobile_call_code', 'mobile'])"
                :phone-number="{ call_code: form.mobile_call_code, phone_number: form.mobile }"
                v-model="mobile"
                name="mobile"
                v-if="weAreCreatingA('coach')
                    || weAreCreatingA('candidate')
                    || weAreCreatingA('id_employee')
                    || weAreCreatingA('client')
                    || weAreCreatingA('supplier')"
            />

            <form-input
                :form="form"
                type="email"
                name="email"
                data-lpignore="true"
                v-if="weAreCreatingA('coach')
                    || weAreCreatingA('candidate')
                    || weAreCreatingA('id_employee')
                    || weAreCreatingA('client')
                    || weAreCreatingA('supplier')"
            />

            <backend-select
                v-if="weAreCreatingA('coach')"
                v-model="form.region_id"
                :route="route('settings.values.index', { setting: 8 })"
                :error="form.errors.get('region_id')"
                :value="field('region_id')"
                object-name-key="value"
                return="id"
                name="region"
                label="region"
                required
            />

            <form-input
                :form="form"
                required
                type="number"
                name="max_trajectories"
                v-if="weAreCreatingA('coach')"
            />

            <form-input
                :form="form"
                type="number"
                name="rebate"
                label="credit"
                v-if="weAreCreatingA('coach')"
            />

            <form-daterange-picker
                :form="form"
                name_1="unavailable_period_start"
                name_2="unavailable_period_end"
                :label="uLang('app.unavailable_period')"
                v-if="$can('update-relations')
                    && weAreCreatingA('coach')"
            />

            <form-select
                v-model="selectedVat"
                :options="vatOptions"
                :custom-label="organisationVatPercentageLabel"
                name="organisation_vat_percentage"
                v-if="$can('update-relations')
                    && weAreCreatingA('coach')"

            />

            <backend-select
                :error="form.errors.get('roles')"
                return="id"
                name="roles"
                label="roles"
                multiple
                v-model="form.roles"
                :value="field('roles')"
                :route="route('roles.index')"
                v-if="$can('update-relations')
                    && (weAreCreatingA('coach')
                    || weAreCreatingA('id_employee')
                    || weAreCreatingA('client')
                    || weAreCreatingA('supplier'))"
            />

            <div class="dv-group-rows" v-if="$can('update-relations')
                        && (weAreCreatingA('coach')
                        || weAreCreatingA('id_employee')
                        || weAreCreatingA('client')
                        || weAreCreatingA('supplier'))">
                <backend-select
                    :error="form.errors.get('trajectory_type_inspector_for')"
                    return="id"
                    ref="inspectorSelect"
                    name="trajectory_type_inspector_for"
                    label="trajectory_type_inspector_for"
                    multiple
                    v-model="form.trajectory_type_inspector_for"
                    :value="field('trajectory_type_inspector_for')"
                    :route="route('trajectories.trajectory_type.active')"
                    :disabled="!form.roles || !form.roles.length || !isRoleSelected(2)"
                />

                <div class="form-group row" v-if="form.trajectory_type_inspector_for && form.trajectory_type_inspector_for.length > 0">
                    <label class="form-control-label col-form-label col-md-3 col-xl-2 col-sm-12"></label>
                    <div class="col-md-9 col-xl-10 col-sm-12 d-flex flex-wrap align-items-center gap-2">
                        <b-button
                            v-for="typeId in form.trajectory_type_inspector_for"
                            :key="'inspector-' + typeId"
                            type="button"
                            size=""
                            variant="primary"
                            class="mr-1 mb-1"
                            @click="openFineTuneModal('inspector', typeId)"
                        >
                            {{ uLang('app.fine_tune_trajectory_type') }}: {{ getTypeName(typeId, 'inspector') }}
                        </b-button>
                    </div>
                </div>
            </div>

            <div class="dv-group-rows" v-if="$can('update-relations')
                        && (weAreCreatingA('coach')
                        || weAreCreatingA('id_employee')
                        || weAreCreatingA('client')
                        || weAreCreatingA('supplier'))">
                <backend-select
                    :error="form.errors.get('trajectory_type_administrator_for')"
                    return="id"
                    ref="administratorSelect"
                    name="trajectory_type_administrator_for"
                    label="trajectory_type_administrator_for"
                    multiple
                    v-model="form.trajectory_type_administrator_for"
                    :value="field('trajectory_type_administrator_for')"
                    :route="route('trajectories.trajectory_type.active')"
                    :disabled="!form.roles || !form.roles.length || !isRoleSelected(3)"
                />

                <div class="form-group row" v-if="form.trajectory_type_administrator_for && form.trajectory_type_administrator_for.length > 0">
                    <label class="form-control-label col-form-label col-md-3 col-xl-2 col-sm-12"></label>
                    <div class="col-md-9 col-xl-10 col-sm-12 d-flex flex-wrap align-items-center gap-2">
                        <b-button
                            v-for="typeId in form.trajectory_type_administrator_for"
                            :key="'administrator-' + typeId"
                            type="button"
                            size=""
                            variant="primary"
                            class="mr-1 mb-1"
                            @click="openFineTuneModal('administrator', typeId)"
                        >
                            {{ uLang('app.fine_tune_trajectory_type') }}: {{ getTypeName(typeId, 'administrator') }}
                        </b-button>
                    </div>
                </div>
            </div>

            <!-- ID-329 -->
            <div class="dv-group-rows" v-if="$can('update-relations')
                        && (weAreCreatingA('coach')
                        || weAreCreatingA('id_employee')
                        || weAreCreatingA('client')
                        || weAreCreatingA('supplier'))">
                <backend-select
                    :error="form.errors.get('trajectory_type_manager_for')"
                    return="id"
                    ref="managerSelect"
                    name="trajectory_type_manager_for"
                    label="trajectory_type_manager_for"
                    multiple
                    v-model="form.trajectory_type_manager_for"
                    :value="field('trajectory_type_manager_for')"
                    :route="route('trajectories.trajectory_type.active')"
                    :disabled="!form.roles || !form.roles.length || !isRoleSelected(1)"
                />

                <div class="form-group row" v-if="form.trajectory_type_manager_for && form.trajectory_type_manager_for.length > 0">
                    <label class="form-control-label col-form-label col-md-3 col-xl-2 col-sm-12"></label>
                    <div class="col-md-9 col-xl-10 col-sm-12 d-flex flex-wrap align-items-center gap-2">
                        <b-button
                            v-for="typeId in form.trajectory_type_manager_for"
                            :key="'manager-' + typeId"
                            type="button"
                            size=""
                            variant="primary"
                            class="mr-1 mb-1"
                            @click="openFineTuneModal('manager', typeId)"
                        >
                            {{ uLang('app.fine_tune_trajectory_type') }}: {{ getTypeName(typeId, 'manager') }}
                        </b-button>
                    </div>
                </div>
            </div>
            <!-- ID-329 -->            

            <dropzone
                ref="dropzone"
                @success="addFile"
                :endpoint="route('files.store')"
                :error="form.errors.get('image_id')"
                name="image"
                v-if="$can('update-relations')
                    && weAreCreatingA('coach')"
            />

            <form-input
                :form="form"
                type="text"
                :hidden="!$can('update-relations')"
                name="citizen_identifier"
                label="citizen_identifier"
                v-if="weAreCreatingA('candidate')"
            />

            <active-select
                return="id"
                v-model="form.active"
                :error="form.errors.get('active')"
            />

            <yes-no-select
                v-if="isUpdate() && weAreCreatingA('coach')"
                v-model="form.collaboration_ended"
                :error="form.errors.get('collaboration_ended')"
                name="collaboration_status"
                :yes-label="uLang('app.collaboration_ended')"
                :no-label="uLang('app.collaboration_active')"
            />

            <yes-no-select
                v-if="weAreCreatingA('candidate') && !$hasType('coach') "
                v-model="form.use_new_credit_calculation"
                :error="form.errors.get('use_new_credit_calculation')"
                name="use_new_credit_calculation"
                label="credit_calculation"
                :yes-label="uLang('app.trajectory_type_dependant')"
                :no-label="uLang('app.coach_credit')"
            />

            <div class="form-group row" v-if="weAreCreatingA('candidate') && !$hasType('coach') ">
                <label for="candidate_ok_survey" class="form-control-label col-form-label col-md-3 col-xl-2 col-sm-12">Geeft toestemming voor KTO: </label>
                <div class="col-md-9 col-xl-10 col-sm-12 d-flex align-items-center">
                    <div style="padding-top:8px">
                        <label>
                            <input type="radio" v-model="form.candidate_ok_survey" :value="1"> Ja
                        </label>
                        <label>
                            <input type="radio" v-model="form.candidate_ok_survey" :value="0"> Nee
                        </label>
                    </div>
                </div>
            </div>

            <module-address
                v-if="!isUpdate()
                    && openInModal
                    && (weAreCreatingA('coach')
                    || weAreCreatingA('candidate')
                    || weAreCreatingA('id_employee')
                    || weAreCreatingA('client')
                    || weAreCreatingA('supplier'))"
                :form="form"
                @addressesUpdated="addressesUpdated"
                :title="uLang('app.add_address')"
                ref="addressModule"
            />

            <backend-select
                :error="form.errors.get('selected_source')"
                name="selected_source"
                label="selected_source"
                :route="route('get-selected-source')"
                track-by="value"
                return="id"
                :value="field('selected_source')"
                v-model="form.selected_source"
                object-name-key="value"
            />

            <!-- TODO: Disabled, need to re-enable later -->
            <b-card
                v-show="weAreCreatingA('coach')"
                :header="uLang('app.website_info')"
                header-tag="h4"
                class="bg-default-card website-info-card"
                :class="!show_website_fields ? 'collapsed-website-info-card' : ''"
                id="web-info"
            >
                <template slot="header">
                    <span>{{ uLang('app.website_info') }}</span>
                    <h5 @click.prevent="toggleWebsiteFields" class="pointer pull-right">
                        <i class="fa pull-left active"
                           :class="show_website_fields ? 'fa-angle-up' : 'fa-angle-down'"
                        />
                        {{ show_website_fields ? 'Inklappen' : 'Uitklappen' }}
                    </h5>
                </template>

                <b-tabs v-if="show_website_fields" class="website-info-tabs">
                    <b-tab class="mt-3" title="Coachpagina" active>
                        <div class="col-md-12">
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <yes-no-select
                                        v-model="form.show_on_website"
                                        name="show_on_website"
                                        :error="form.errors.get('show_on_website')"
                                    />
                                </div>
                            </div>

                            <div class="row form-group">
                                <div class="col-md-12">
                                    <form-input
                                        :form="form"
                                        name="coach_title"
                                        label="title"
                                    />
                                </div>
                            </div>

                            <div class="row form-group">
                                <div class="col-md-12">
                                    <basic-ckeditor
                                        v-model="form.content"
                                        name="content"
                                        label="what_can_you_expect_from_me"
                                        editor-style="max-height: 300px"
                                    />
                                </div>
                            </div>

                            <div class="row form-group">
                                <div class="col-md-12">
                                    <basic-ckeditor
                                        v-model="form.webtext2"
                                        name="webtext2"
                                        label="webtext2"
                                        editor-style="max-height: 300px"
                                    />
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab class="mt-3" title="Overige info">
                        <div class="row">
                            <div class="col-md-12">

                                <div class="row form-group">
                                    <div class="col-md-12">
                                        <yes-no-select
                                            v-model="form.is_ecoaching"
                                            name="is_ecoaching"
                                            :yes-label="uLang('app.provides_e_coaching')"
                                            :no-label="uLang('app.does_not_provide_e_coaching')"
                                            :error="form.errors.get('is_ecoaching')"
                                        />
                                    </div>
                                </div>

                                <div v-if="show_advanced_fields" class="row form-group">
                                    <div class="col-md-12">
                                        <form-input
                                            :form="form"
                                            name="department"
                                            label="department"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab class="mt-3" :title="uLang('app.website_trajectories')">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row form-group">
                                    <div class="col-md-12">
                                        <table class="website-info-table">
                                            <tr>
                                                <th colspan="4">{{ uLang('app.website_trajectories') }}</th>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <th>{{ uLang('app.specialist') }}</th>
                                                <th>{{ uLang('app.expert') }}</th>
                                                <th>{{ uLang('app.none') }}</th>
                                            </tr>
                                            <tr>
                                                <th>{{ uLang('app.select_all') }}</th>
                                                <th>
                                                    <input type="checkbox"
                                                           v-model="select_all.trajectories.specialist"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           @change="selectDeselectAll('trajectories', 'specialist')"/>
                                                </th>
                                                <th>
                                                    <input type="checkbox"
                                                           v-model="select_all.trajectories.expert"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           @change="selectDeselectAll('trajectories', 'expert')"/>
                                                </th>
                                                <th>
                                                    <input type="checkbox"
                                                           v-model="select_all.trajectories.no"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           @change="selectDeselectAll('trajectories', 'no')"/>
                                                </th>
                                            </tr>
                                            <tr class="checkbox-matrix" v-for="trajectory in website.trajectories"
                                                :key="trajectory.id">
                                                <td>{{ trajectory.value }}</td>
                                                <td>
                                                    <input type="checkbox"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           v-model="form.website.trajectories[trajectory.id].specialist"/>
                                                </td>
                                                <td>
                                                    <input type="checkbox"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           v-model="form.website.trajectories[trajectory.id].expert"/>
                                                </td>
                                                <td>
                                                    <input type="checkbox"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           v-model="form.website.trajectories[trajectory.id].no"/>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab class="mt-3" :title="uLang('app.website_services')">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row form-group">
                                    <div class="col-md-12">
                                        <table class="website-info-table">
                                            <tr>
                                                <th colspan="4">{{ uLang('app.website_services') }}</th>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <th>{{ uLang('app.specialist') }}</th>
                                                <th>{{ uLang('app.expert') }}</th>
                                                <th>{{ uLang('app.none') }}</th>
                                            </tr>
                                            <tr>
                                                <th>{{ uLang('app.select_all') }}</th>
                                                <th>
                                                    <input type="checkbox"
                                                           v-model="select_all.services.specialist"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           @change="selectDeselectAll('services', 'specialist')"/>
                                                </th>
                                                <th>
                                                    <input type="checkbox"
                                                           v-model="select_all.services.expert"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           @change="selectDeselectAll('services', 'expert')"/>
                                                </th>
                                                <th>
                                                    <input type="checkbox"
                                                           v-model="select_all.services.no"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           @change="selectDeselectAll('services', 'no')"/>
                                                </th>
                                            </tr>
                                            <tr class="checkbox-matrix" v-for="service in website.services"
                                                :key="service.id">
                                                <td>{{ service.value }}</td>
                                                <td>
                                                    <input type="checkbox"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           v-model="form.website.services[service.id].specialist"/>
                                                </td>
                                                <td>
                                                    <input type="checkbox"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           v-model="form.website.services[service.id].expert"/>
                                                </td>
                                                <td>
                                                    <input type="checkbox"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           v-model="form.website.services[service.id].no"/>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab class="mt-3" :title="uLang('app.website_target_audiences')">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row form-group">
                                    <div class="col-md-12">
                                        <table class="website-info-table">
                                            <tr>
                                                <th colspan="4">{{ uLang('app.website_target_audiences') }}</th>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <th>{{ uLang('app.specialist') }}</th>
                                                <th>{{ uLang('app.expert') }}</th>
                                                <th>{{ uLang('app.none') }}</th>
                                            </tr>
                                            <tr>
                                                <th>{{ uLang('app.select_all') }}</th>
                                                <th>
                                                    <input type="checkbox"
                                                           v-model="select_all.target_audiences.specialist"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           @change="selectDeselectAll('target_audiences', 'specialist')"/>
                                                </th>
                                                <th>
                                                    <input type="checkbox"
                                                           v-model="select_all.target_audiences.expert"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           @change="selectDeselectAll('target_audiences', 'expert')"/>
                                                </th>
                                                <th>
                                                    <input type="checkbox"
                                                           v-model="select_all.target_audiences.no"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           @change="selectDeselectAll('target_audiences', 'no')"/>
                                                </th>
                                            </tr>
                                            <tr class="checkbox-matrix"
                                                v-for="target_audience in website.target_audiences"
                                                :key="target_audience.id">
                                                <td>{{ target_audience.value }}</td>
                                                <td>
                                                    <input type="checkbox"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           v-model="form.website.target_audiences[target_audience.id].specialist"/>
                                                </td>
                                                <td>
                                                    <input type="checkbox"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           v-model="form.website.target_audiences[target_audience.id].expert"/>
                                                </td>
                                                <td>
                                                    <input type="checkbox"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           v-model="form.website.target_audiences[target_audience.id].no"/>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab class="mt-3" :title="uLang('app.website_branches')">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row form-group">
                                    <div class="col-md-12">
                                        <table class="website-info-table">
                                            <tr>
                                                <th colspan="4">{{ uLang('app.website_branches') }}</th>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <th>{{ uLang('app.specialist') }}</th>
                                                <th>{{ uLang('app.expert') }}</th>
                                                <th>{{ uLang('app.none') }}</th>
                                            </tr>
                                            <tr>
                                                <th>{{ uLang('app.select_all') }}</th>
                                                <th>
                                                    <input type="checkbox"
                                                           v-model="select_all.branches.specialist"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           @change="selectDeselectAll('branches', 'specialist')"/>
                                                </th>
                                                <th>
                                                    <input type="checkbox"
                                                           v-model="select_all.branches.expert"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           @change="selectDeselectAll('branches', 'expert')"/>
                                                </th>
                                                <th>
                                                    <input type="checkbox"
                                                           v-model="select_all.branches.no"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           @change="selectDeselectAll('branches', 'no')"/>
                                                </th>
                                            </tr>
                                            <tr class="checkbox-matrix" v-for="branch in website.branches"
                                                :key="branch.id">
                                                <td>{{ branch.value }}</td>
                                                <td>
                                                    <input type="checkbox"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           v-model="form.website.branches[branch.id].specialist"/>
                                                </td>
                                                <td>
                                                    <input type="checkbox"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           v-model="form.website.branches[branch.id].expert"/>
                                                </td>
                                                <td>
                                                    <input type="checkbox"
                                                           v-bind:true-value="1"
                                                           v-bind:false-value="0"
                                                           v-model="form.website.branches[branch.id].no"/>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
            </b-card>
        </form>

        <div
            class="form-group fr-absolute"
            v-if="weAreCreatingA('coach')
                || weAreCreatingA('candidate')
                || weAreCreatingA('id_employee')
                || weAreCreatingA('client')
                || weAreCreatingA('supplier')"
        >
            <input
                :disabled="form.busy"
                type="submit"
                class="btn btn-brand"
                @click.prevent="store"
                :value="uLang('app.save')"
            />
        </div>


        <b-modal ref="fineTuneModal" :title="currentFineTune" hide-footer>
            <div v-if="modalDataFineTune.trajectories.length">
                <div v-for="opt in modalDataFineTune.trajectories" :key="opt.value">
                <label>
                    <input
                    type="checkbox"
                    :value="opt.value"
                    v-model="modalDataFineTune.selected"
                    >
                    {{ opt.text }}
                </label>
                </div>
            </div>

            <b-button variant="primary" @click="saveFineTune()">{{ uLang('app.save') }}</b-button>
        </b-modal>
    </div>

    
</template>

<script>
    import Form from '~/Form/Form';
    import FormMixin from '~/mixins/form';
    import SuccessfullyStoredAlert from "~/Swals/SuccessfullyStoredAlert";
    import SuccessfullyUpdatedAlert from "~/Swals/SuccessfullyUpdatedAlert";
    import YesNoSelect from "../../../elements/selects/yes-no"
    import Ckeditor from "../../../elements/action-document-ckeditor"
    import BasicCkeditor from "../../../elements/ckeditor"
    import Multiselect from 'vue-multiselect'
    import BModal from "bootstrap-vue/lib/components/modal"

    export default {
        name: 'form-admin-relation',
        components: { BasicCkeditor, Ckeditor, YesNoSelect, Multiselect, 'b-modal': BModal, },
        mixins: [FormMixin],

        props: {
            id: {
                required: false,
            },
            showOrganisation: {
                type: Boolean,
                default: true,
            },
            organisationId: {
                default: null,
                required: false,
            },
            openInModal: {
                default: true,
            }
        },

        data() {
                

            return {
                isInitializing: false,
                initTypesReady: true,
                initOrganisationHydrated: true,
                show_website_fields: true,
                show_advanced_fields: true,
                vatOptions: [
                    {name: '21%', value: '21'},
                    {name: '9%', value: '9'},
                    {name: '0%', value: '0'},
                ],
                selectedVat: null,
                test: null,
                entity: 'relation',
                doneLoadingSettingValues: false,
                select_all: {
                    trajectories: {
                        specialist: 0,
                        expert: 0,
                        no: 0
                    },
                    branches: {
                        specialist: 0,
                        expert: 0,
                        no: 0
                    },
                    target_audiences: {
                        specialist: 0,
                        expert: 0,
                        no: 0
                    },
                    services: {
                        specialist: 0,
                        expert: 0,
                        no: 0
                    }
                },
                website: {
                    website_trajectories: [],
                    website_services: [],
                    website_target_audiences: [],
                    website_branches: [],
                },
                form: new Form({
                    active: 0,
                    first_letters: '',
                    title: null,
                    first_name: '',
                    prefix: '',
                    last_name: '',
                    email: '',
                    sickness_started_at: '',
                    birth_date: '',
                    phone_number: '',
                    phone_number_call_code: '+31',
                    type_id: null,
                    mobile: '',
                    image_id: null,
                    mobile_call_code: '+31',
                    job_title: '',
                    image: '',
                    unavailable_period: {},
                    unavailable_period_start: '',
                    unavailable_period_end: '',
                    organisation_vat_percentage: null,
                    selected_source: null,
                    addresses: [],
                    organisation_id: null,
                    roles: null,
                    trajectory_type_inspector_for: null,
                    trajectory_type_administrator_for: null,
                    trajectory_type_manager_for: null,
                    trajectories_inspector: null,
                    trajectories_administrator: null,
                    trajectories_manager: null,
                    max_trajectories: null,
                    citizen_identifier: null,
                    rebate: null,
                    region_id: null,
                    collaboration_ended: false,
                    use_new_credit_calculation: 1,
                    candidate_ok_survey: null,
                    show_on_website: 0,
                    coach_title: '',
                    department: '',
                    specialization: '',
                    is_ecoaching: null,
                    content: '<p>&nbsp;</p>',
                    webtext2: '<p>&nbsp;</p>',
                    website: {
                        trajectories: {},
                        services: {},
                        target_audiences: {},
                        branches: {},
                    },
                }),
                phone_number: null,
                mobile: null,
                selected_relation_type: null,
                swal: false,
                isSetByType: false,
                relation: null,
                allTrajectories: [],  // <-- master list of all trajectories for the modal fine tune
                modalDataFineTune: {
                    role: null,
                    typeId: null,
                    trajectories: [],
                    selected: []
                },
                currentFineTune: '',
                noTypeId: null, // ID for the 'Geen trajecttype' type (orphans type)
                //hasTriggeredTrajectoriesSelect: false,
            };
        },

        watch: {
            // modalDataFineTune: {
            //     handler(newVal) {
            //         console.log("Fine tune selected trajectories change:", newVal.selected);
            //     },
            //     deep: true,
            // },
            form(newVal) {
                // DEBUG console.log("form prop changed:", newVal);
            },
            selected_relation_type: {
                handler(newVal, oldVal) {
                    if (!newVal) {
                        return;
                    }
                    this.form.type_id = newVal.id;
                    this.retrieveOrganisationByType();
                    this.$nextTick(() => {
                        if (this.weAreCreatingA('coach')) {
                            this.$refs.dropzone.$refs.dropzone.dropzone.on('removedfile', (file) => {
                                this.form.image_id = null;
                            });
                        }
                    });
                }
            },
            selectedVat(vat) {
                this.form.organisation_vat_percentage = vat.value;
            },
            'form.organisation_id': {
                handler: async function (organisationId) {
                    // Set the selected relation type based on the organisation.
                    // Guard against edit-hydration races: during initial load we must not overwrite the relation's own type.
                    if (this.isInitializing ||
                        this.isSetByType ||
                        (organisationId === null || organisationId === undefined)) {
                        return;
                    }

                    const {data} = await window.axios.get(route('organisations.show', {organisation: organisationId}))

                    // if (this.isSetByType) {
                    //     return;
                    // }

                    this.selected_relation_type = data.type
                    if (data.vat_percentage !== null) {
                        this.selectedVat = this.vatOptions.find(o => o.value == data.vat_percentage);
                        this.form.organisation_vat_percentage = data.vat_percentage
                    }
                },
            },

            doTheMerge: {
                handler: function () {
                    this.fillCoachWebsiteData()
                },
            },

            organisationId: {
                immediate: true,
                handler: function (organisationId) {
                    this.form.organisation_id = organisationId;
                },
            },

            phone_number() {
                this.form.phone_number_call_code = this.phone_number.call_code;
                this.form.phone_number = this.phone_number.number;
            },
            mobile() {
                this.form.mobile_call_code = this.mobile.call_code;
                this.form.mobile = this.mobile.number;
            },
            roles(newVal, oldVal) {
                // When we delete all roles we will empty trajectories
                if (!this.form.roles || !this.form.length)
                    return;

                if (!this.isRoleSelected(2))
                {   
                    this.form.trajectory_type_inspector_for = null;
                }

                if (!this.isRoleSelected(3))
                {
                    this.form.trajectory_type_administrator_for = null;
                }

                if (!this.isRoleSelected(4))
                {
                    this.form.trajectory_type_manager_for = null;
                }
            },
            // When the inspector trajectory types change, we need to update the trajectories for fine-tune
            'form.trajectory_type_inspector_for': {
                handler(newVal, oldVal) {

                    // If the new type_id is not in the fine-tune trajectories, add all of the trajectories for that type
                    //   as it's a new added type, EXCEPT if it's the 'Geen trajecttype' type (orphans type).

                    if (
                        newVal &&
                        Array.isArray(newVal) &&
                        newVal.length > 0
                    ) {
                        // For each selected typeId, check if we already have items for that type
                        newVal.forEach(typeId => {
                            const hasType = (this.form.trajectories_inspector || []).some(
                                t => Number(t.trajectory_type_id) === Number(typeId)
                            );

                            // DEBUG console.log('Checking typeId:', typeId, 'hasType:', hasType);

                            if (!hasType && typeId !== this.noTypeId) {
                                // Don't have it: add all trajectories for this typeId as it's a new added type (EXCEPT for 'Geen trajecttype')
                                const toAdd = this.allTrajectories
                                    .filter(t => Number(t.trajectory_type_id) === Number(typeId))
                                    .map(t => ({
                                        id: t.id,
                                        name: t.name,
                                        trajectory_type_id: t.trajectory_type_id
                                    }));
                                if (!Array.isArray(this.form.trajectories_inspector)) {
                                    this.form.trajectories_inspector = [];
                                }
                                this.form.trajectories_inspector = [
                                    ...this.form.trajectories_inspector,
                                    ...toAdd
                                ];
                            }
                        });
                    }

                    // If deleting a type we will remove all trajectories for that type in the fine-tune collection
                    if (oldVal && Array.isArray(oldVal)) {
                        // Find which typeIds were removed
                        const removedTypeIds = oldVal.filter(typeId => !newVal.includes(typeId));
                        if (removedTypeIds.length > 0 && Array.isArray(this.form.trajectories_inspector)) {
                            this.form.trajectories_inspector = this.form.trajectories_inspector.filter(
                                t => !removedTypeIds.includes(Number(t.trajectory_type_id))
                            );
                        }
                    }

                    
                },
                deep: true,
            },

            // When the administrator trajectory types change, we need to update the trajectories for fine-tune
            'form.trajectory_type_administrator_for': {
                handler(newVal, oldVal) {

                    // If the new type_id is not in the fine-tune trajectories, add all of the trajectories for that type
                    //   as it's a new added type, EXCEPT if it's the 'Geen trajecttype' type (orphans type).
                    if (
                        newVal &&
                        Array.isArray(newVal) &&
                        newVal.length > 0
                    ) {
                        // For each selected typeId, check if we already have items for that type
                        newVal.forEach(typeId => {
                            const hasType = (this.form.trajectories_administrator || []).some(
                                t => Number(t.trajectory_type_id) === Number(typeId)
                            );
                            if (!hasType && typeId !== this.noTypeId) {
                                // Don't have it: add all trajectories for this typeId as it's a new added type (EXCEPT for 'Geen trajecttype')
                                const toAdd = this.allTrajectories
                                    .filter(t => Number(t.trajectory_type_id) === Number(typeId))
                                    .map(t => ({
                                        id: t.id,
                                        name: t.name,
                                        trajectory_type_id: t.trajectory_type_id
                                    }));
                                if (!Array.isArray(this.form.trajectories_administrator)) {
                                    this.form.trajectories_administrator = [];
                                }
                                this.form.trajectories_administrator = [
                                    ...this.form.trajectories_administrator,
                                    ...toAdd
                                ];
                            }
                        });
                    }

                    // If deleting a type we will remove all trajectories for that type in the fine-tune collection
                    if (oldVal && Array.isArray(oldVal)) {
                        // Find which typeIds were removed
                        const removedTypeIds = oldVal.filter(typeId => !newVal.includes(typeId));
                        if (removedTypeIds.length > 0 && Array.isArray(this.form.trajectories_administrator)) {
                            this.form.trajectories_administrator = this.form.trajectories_administrator.filter(
                                t => !removedTypeIds.includes(Number(t.trajectory_type_id))
                            );
                        }
                    }

                    
                },
                deep: true,
            },

            // When the manager trajectory types change, we need to update the trajectories for fine-tune
            'form.trajectory_type_manager_for': {
                handler(newVal, oldVal) {

                    // If the new type_id is not in the fine-tune trajectories, add all of the trajectories for that type
                    //   as it's a new added type, EXCEPT if it's the 'Geen trajecttype' type (orphans type).
                    if (
                        newVal &&
                        Array.isArray(newVal) &&
                        newVal.length > 0
                    ) {
                        // For each selected typeId, check if we already have items for that type
                        newVal.forEach(typeId => {
                            const hasType = (this.form.trajectories_manager || []).some(
                                t => Number(t.trajectory_type_id) === Number(typeId)
                            );
                            if (!hasType && typeId !== this.noTypeId) {
                                // Don't have it: add all trajectories for this typeId as it's a new added type (EXCEPT for 'Geen trajecttype')
                                const toAdd = this.allTrajectories
                                    .filter(t => Number(t.trajectory_type_id) === Number(typeId))
                                    .map(t => ({
                                        id: t.id,
                                        name: t.name,
                                        trajectory_type_id: t.trajectory_type_id
                                    }));
                                if (!Array.isArray(this.form.trajectories_manager)) {
                                    this.form.trajectories_manager = [];
                                }
                                this.form.trajectories_manager = [
                                    ...this.form.trajectories_manager,
                                    ...toAdd
                                ];
                            }
                        });
                    }

                    // If deleting a type we will remove all trajectories for that type in the fine-tune collection
                    if (oldVal && Array.isArray(oldVal)) {
                        // Find which typeIds were removed
                        const removedTypeIds = oldVal.filter(typeId => !newVal.includes(typeId));
                        if (removedTypeIds.length > 0 && Array.isArray(this.form.trajectories_manager)) {
                            this.form.trajectories_manager = this.form.trajectories_manager.filter(
                                t => !removedTypeIds.includes(Number(t.trajectory_type_id))
                            );
                        }
                    }

                    
                },
                deep: true,
            },
        },

        computed: {
            roles() {
                return this.form.roles;
            },
            doTheMerge() {
                return this.doneLoadingSettingValues && this.relation !== null
            },
        },

        created: function () {
            if (this.isUpdate()) {
                // During edit: multiple async hydrations can finish out-of-order.
                // Keep an explicit guard until required initial hydrations are done.
                this.isInitializing = true;
                this.initTypesReady = false;
                this.initOrganisationHydrated = false;
            }

            this.$on('afterRetrieve', function (data) {
                this.afterRetrieve(data);
            });

            this.$on('onStore', function () {
                this.onStore();
            });

            this.$on('afterStore', this.afterStore);
            this.$on('afterUpdate', this.afterUpdate);

            this.$on('formReady', this.formReady);

            this.loadAllTrajectories();

        },

        mounted() {
            this.getAllSettingValues();
        },

        methods: {
            finishInitializationIfReady() {
                if (!this.isInitializing) {
                    return;
                }

                if (this.initTypesReady && this.initOrganisationHydrated) {
                    this.isInitializing = false;
                }
            },

            async hydrateOrganisationMeta(organisationId) {
                if (organisationId === null || organisationId === undefined) {
                    this.initOrganisationHydrated = true;
                    this.finishInitializationIfReady();
                    return;
                }

                try {
                    const {data} = await window.axios.get(route('organisations.show', {organisation: organisationId}))

                    if (data && data.vat_percentage !== null) {
                        this.selectedVat = this.vatOptions.find(o => o.value == data.vat_percentage);
                        this.form.organisation_vat_percentage = data.vat_percentage
                    }
                } finally {
                    this.initOrganisationHydrated = true;
                    this.finishInitializationIfReady();
                }
            },

            async getAllSettingValues() {
                let that = this
                await Promise.allSettled([
                    that.getSettingValues('website_target_audiences'),
                    that.getSettingValues('website_branches'),
                    that.getSettingValues('website_services'),
                    that.getSettingValues('website_trajectories')
                ]).then(function () {
                    that.doneLoadingSettingValues = true
                })

            },
            async getSettingValues(settingName, removableString = 'website_') {
                const {data} = await window.axios.get(route('settings.values.index', {setting: settingName}));

                this.prepWebsiteFormData(settingName.substring(removableString.length), data)

                this.website[settingName.substring(removableString.length)] = data
            },
            prepWebsiteFormData(settingName, data) {
                for (let item in data) {
                    this.form.website[settingName][data[item].id] = {
                        specialist: false,
                        expert: false,
                        no: false
                    }
                }
            },
            /**
             * @param website_type
             * Branches, services, target_audiences or trajectories
             * @param type
             * Specialist, expert, or simply no
             */
            selectDeselectAll(website_type, type) {
                if (
                    !(['branches', 'services', 'target_audiences', 'trajectories'].includes(website_type)) &&
                    !(['specialist', 'expert', 'no'].includes(type))
                ) {
                    return;
                }

                Object.keys(this.form.website[website_type]).forEach((key) => {
                    this.form.website[website_type][key][type] = this.select_all[website_type][type]
                })
            },
            fillCoachWebsiteData() {
                this.form.website.trajectories = {
                    ...this.form.website.trajectories,
                    ...JSON.parse(this.relation.trajectories)
                }
                this.form.website.services = {
                    ...this.form.website.services,
                    ...JSON.parse(this.relation.services)
                }
                this.form.website.target_audiences = {
                    ...this.form.website.target_audiences,
                    ...JSON.parse(this.relation.target_audiences)
                }
                this.form.website.branches = {
                    ...this.form.website.branches,
                    ...JSON.parse(this.relation.branches)
                }
            },
            toggleWebsiteFields() {
                this.show_website_fields = !this.show_website_fields;
            },
            async retrieveOrganisationByType() {
                if (this.selected_relation_type.system_name == 'id_employee') {
                    const {data} = await window.axios.get(route('organisations.employee.type', {type: this.selected_relation_type.id}));
                    this.isSetByType = true;
                }
            },
            organisationVatPercentageLabel(option) {
                return option.value + '%'
            },
            weAreCreatingA(type) {
                return this.selected_relation_type && type == this.selected_relation_type.system_name;
            },
            isRoleSelected(checkedRole) {
                if (!Array.isArray(this.form.roles))
                    return false;

                for (let role in this.form.roles) {
                    if (this.form.roles.hasOwnProperty(role) && this.form.roles[role] === checkedRole) {
                        return true;
                    }
                }

                return false;
            },

            addFile(file) {
                this.form.image_id = file.id;
            },

            show() {
                this.$router.push({
                    name: 'admin.relations.view',
                    params: { id: this.id },
                });
            },

            formReady() {
                if (this.weAreCreatingA('coach')) {
                    this.$refs.dropzone.$refs.dropzone.dropzone.on('removedfile', (file) => {
                        this.form.image_id = null;
                    });
                }
            },

            onStore() {
                this.form.birth_date = this.form.birth_date !== '' && this.form.birth_date !== null ? moment(this.form.birth_date).format('YYYY-MM-DD') : null;

                let notype = [];

                if (Array.isArray(this.form.trajectories_inspector)) {
                    this.form.trajectories_inspector.forEach(item => {
                        if (!item.hasOwnProperty('trajectory_type_id')) {
                            notype.push(item);
                        }
                    });
                }
                if (Array.isArray(this.form.trajectories_administrator)) {
                    this.form.trajectories_administrator.forEach(item => {
                        if (!item.hasOwnProperty('trajectory_type_id')) {
                            notype.push(item);
                        }
                    });
                }
                if (Array.isArray(this.form.trajectories_manager)) {
                    this.form.trajectories_manager.forEach(item => {
                        if (!item.hasOwnProperty('trajectory_type_id')) {
                            notype.push(item);
                        }
                    });
                }
            },

            addressesUpdated(addresses) {
                let newAddresses = addresses.map((address) => {
                    return address.id;
                });

                let addressesToDelete = _.difference(this.form.addresses, newAddresses);

                let len = addressesToDelete.length;
                for (let i = 0; i < len; i++) {
                    axios.delete(route('addresses.destroy', { 'address': addressesToDelete[i] }));
                }

                this.form.addresses = newAddresses;
            },

            afterStore(data) {
                if (this.openInModal) {
                    new SuccessfullyStoredAlert({ entity: this.lang('app.relation') }).show()
                        .then((buttonPressed) => {
                            if (buttonPressed === 'create_another') {
                                this.$refs.dropzone.removeAllFiles();
                                this.$refs.addressModule.clear();
                            } else if (buttonPressed === 'show') {
                                this.$router.push({ name: 'admin.relations.view', params: { id: data.id } });
                            }
                        });
                }

                if (!this.openInModal) {
                    this.$snotify.info(uLang('app.created'),
                        uLang('app.entity_created', { entity: uLang('app.relation') }));
                }

                this.$emit('relationStored', data)
            },

            afterUpdate(data) {
                new SuccessfullyUpdatedAlert({ entity: this.lang('app.relation') }).show()
                    .then(() => {
                        this.$router.push({ name: 'admin.relations.view', params: { id: this.id } });
                    });
            },

            onTypesRetrieved() {
                if (this.relation) {
                    if (this.relation.mobile_call_code === null) {
                        this.form.mobile_call_code = '+31';
                    }

                    if (this.relation.phone_number_call_code === null) {
                        this.form.phone_number_call_code = '+31';
                    }

                    // Set type
                    this.selected_relation_type = this.relation.type;
                    this.initTypesReady = true;
                    this.finishInitializationIfReady();

                    //show current image
                    if (this.relation.image === null || typeof this.relation.image === 'undefined') {
                        return;
                    }

                    let currentImage = {
                        name: this.relation.image.name,
                        size: 12345
                    };

                    this.$nextTick(() => {
                        this.$refs.dropzone.$refs.dropzone.dropzone.emit('addedfile', currentImage);
                        this.$refs.dropzone.$refs.dropzone.dropzone.emit('thumbnail', currentImage, route('resource.files.show', { 'file': this.relation.image_id }));
                        this.$refs.dropzone.$refs.dropzone.dropzone.emit('complete', currentImage);
                        this.$refs.dropzone.$refs.dropzone.dropzone.on('complete', currentImage);
                    })
                }
            },

            async afterRetrieve(relation) {
                
                this.relation = relation;
                // DEBUG console.log('relation', this.relation);
                // DEBUG console.log('form', this.form);

                if (this.isInitializing) {
                    await this.hydrateOrganisationMeta(this.form.organisation_id);
                }

                let notype = [];

                if (Array.isArray(this.form.trajectories_inspector)) {
                    this.form.trajectories_inspector.forEach(item => {
                        if (!item.hasOwnProperty('trajectory_type_id') || item.trajectory_type_id === null) {
                            notype.push(item);
                        }
                    });
                }
                if (Array.isArray(this.form.trajectories_administrator)) {
                    this.form.trajectories_administrator.forEach(item => {
                        if (!item.hasOwnProperty('trajectory_type_id') || item.trajectory_type_id === null) {
                            notype.push(item);
                        }
                    });
                }
                if (Array.isArray(this.form.trajectories_manager)) {
                    this.form.trajectories_manager.forEach(item => {
                        if (!item.hasOwnProperty('trajectory_type_id') || item.trajectory_type_id === null) {
                            notype.push(item);
                        }
                    });
                }
            },

            getTypeName(typeId, role) {
                let options = [];

                if (role === 'inspector') {
                    options = this.$refs.inspectorSelect?.result || [];
                } else if (role === 'administrator') {
                    options = this.$refs.administratorSelect?.result || [];
                } else if (role === 'manager') {
                    options = this.$refs.managerSelect?.result || [];
                }

                const found = options.find(option => option.id === typeId);
                return found ? found.name : 'Unknown';
            },

           /**
            * Opens modal to fine-tune trajectories for a specific role and trajectory type
            * 
            * The form.trajectories_inspector and form.trajectories_administrator have structure: {id, name, trajectory_type_id}
            * Modal will show the trajectories for the selected type, checked for the trajectories the user is currently assigned to,
            *  and allow to select/deselect them
            * 
            * @param role 
            * @param typeId 
            */
            openFineTuneModal(role, typeId) {

                // DEBUG console.log('form.trajectories_inspector', this.form.trajectories_inspector);
                // DEBUG console.log('form.trajectories_administrator', this.form.trajectories_administrator)

                // Find all trajectories for the selected typeId
                const trajectoriesForType = this.allTrajectories.filter(t => t.trajectory_type_id === typeId);

                // Get currently assigned trajectories for that role
                let currentAssigned = [];
                let roleName = '';

                if (role === 'inspector') {
                    currentAssigned = (this.form.trajectories_inspector || []).map(t => Number(t.id));
                    roleName = uLang('app.trajectory_inspector');
                } else if (role === 'administrator') {
                    currentAssigned = (this.form.trajectories_administrator || []).map(t => Number(t.id));
                    roleName = uLang('app.trajectory_administrator');
                } else if (role === 'manager') {
                    currentAssigned = (this.form.trajectories_manager || []).map(t => Number(t.id));
                    roleName = uLang('app.trajectory_manager');
                }

                // DEBUG console.log('currentAssigned', currentAssigned);
                // DEBUG console.log('trajectoriesForType', trajectoriesForType);

                // Extract IDs of trajectories already assigned for this type
                const selected = trajectoriesForType
                    .map(t => Number(t.id))
                    .filter(id => currentAssigned.includes(id));

                // DEBUG console.log('selected', selected);

                const checkboxOptions = trajectoriesForType.map(t => ({
                    text: t.name,
                    value: t.id,
                }));

                // Prepare modal data
                this.modalDataFineTune = {
                    role,
                    typeId,
                    trajectories: [...checkboxOptions],
                    selected: [...selected], // force Vue to see a new array
                };

                this.currentFineTune = uLang('app.fine_tune_trajectory_type') + ' ('+roleName+') voor: ' + this.getTypeName(typeId, role);

                this.$nextTick(() => {
                    this.modalDataFineTune.selected = [...selected]; // force Vue to see a new array
                });

                // DEBUG console.log('modalDataFineTune selected:', this.modalDataFineTune.selected);

                this.$nextTick(() => {
                    this.$refs.fineTuneModal.show();
                });
                
            },

            /**
             * Saves the fine-tuned trajectories for the selected role and trajectory type
             * When saving the modal will provide the selected IDs and the type,
             * and we will update the form by removing all trajectories of that type
             * and adding the selected ones.
             * This way, in the backend we will receive a clean list of objects {id, name, trajectory_type_id} so
             *  we can sync by type directly.
             */
            saveFineTune() {
                const selectedIds = this.modalDataFineTune.selected.map(Number);
                const { role, typeId } = this.modalDataFineTune;

                // DEBUG console.log('Saving selected IDs:', selectedIds);
                // DEBUG console.log('Before saving form data:', this.form.trajectories_administrator, this.form.trajectories_inspector);

                const targetField = role === 'inspector' ? 'trajectories_inspector' : role === 'administrator' ? 'trajectories_administrator' : 'trajectories_manager';

                // Ensure array exists
                if (!Array.isArray(this.form[targetField])) {
                    this.form[targetField] = [];
                }

                // Remove all items for this typeId
                this.form[targetField] = this.form[targetField].filter(t => Number(t.trajectory_type_id) !== Number(typeId));

                // 2. Add the selected ones
                const newAssignments = selectedIds.map(id => ({
                    id: Number(id),
                    trajectory_type_id: Number(typeId)
                }));

                // Reassign
                this.form[targetField] = [...this.form[targetField], ...newAssignments];

                // DEBUG console.log('AFTER saving form data:', this.form.trajectories_administrator, this.form.trajectories_inspector);

                this.$refs.fineTuneModal.hide();
            },

            loadAllTrajectories() {
                axios.get('/api/admin/trajectories/list')
                    .then(({ data }) => {
                        // DEBUG console.log(data);
                        this.allTrajectories = data;
                    });

                // Load the 'Geen trajecttype' type (orphans type) to handle this specific type - no autopopulate when added
                axios.get('/api/admin/trajectories/trajectory_type/orphans_type_id')
                    .then(({ data }) => {
                        // DEBUG console.log(data);
                        this.noTypeId = data;
                    });
            }
        },
    };
</script>

<style lang="css">
    .dz-details .dz-size, .dz-success-mark, .dz-error-mark {
        display: none;
    }

    .dz-remove {
        margin-right: 15px;
    }

    .dz-image img {
        max-width: 100%;
        max-height: 200px;
    }

    .multiselect--active {
        z-index: 21;
    }

    .website-info-card {
        margin-top: 40px;
        margin-bottom: 20px;
    }

    .collapsed-website-info-card > .card-block {
        min-height: 0;
        padding: 0
    }

    .website-info-card > .card-header {
        margin: 0;
    }

    th {
        text-align: center;
    }

    .website-info-table > tr > th {
        min-width: 75px;
    }

    .checkbox-matrix > td:nth-child(1n + 2) {
        text-align: center;
        /* center checkbox horizontally */
        vertical-align: middle;
        /* center checkbox vertically */
    }

    .dv-group-rows {
        /* border: 1px dotted #ddd; */
        padding: 1em 0.5em;
        margin-bottom: 0.95em;
        background-color: rgba(235, 242, 246, 0.5);
    }
</style>
